import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import "./Numbers.css";
import { Images } from "../../../../helpers/Images";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const Numbers = () => {
  const data = [
    { year: "2020", students: 25 },
    { year: "2021", students: 200 },
    { year: "2022", students: 385 },
    { year: "2023", students: 525 },
    { year: "2024", students: 575 },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: "30px 20px", sm: "30px 60px", lg: "50px 120px" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "#fff",
        maxWidth: "1500px",
        margin: "auto",
      }}
    >
      <Typography
        variant={"h2"}
        sx={{
          textAlign: "center",
          fontSize: "35px",
          fontWeight: "500",
          color: "primary.darker",
        }}
      >
        We Do Challenge Numbers
      </Typography>
      <Box
        sx={{
          height: "3px",
          width: "150px",
          backgroundColor: "primary.main",
          margin: "auto",
          marginTop: "10px",
        }}
      />
      <Typography
        variant={"p"}
        sx={{
          textAlign: "center",
          color: "primary.darker",
          maxWidth: "900px",
          margin: "30px auto 20px auto",
          fontSize: "17px",
        }}
      >
        From the start in 2020, WeDoChallenge® has grown rapidly. Each year, it
        has expanded to include more organisations and reach more children and
        young people. This growth reflects its dedication to empowering the next
        generation. By offering new opportunities and engaging more
        participants, it continues to make a positive impact on communities.
      </Typography>

      {/* Student Growth Chart */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          margin: "0px auto",
          padding: "10px",
          height: { xs: "300px", md: "400px" },
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 10, right: 30, left: 20, bottom: 30 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="year"
              label={{ value: "Year", position: "bottom" }}
            />
            <YAxis
              label={{
                value: "Number of Students",
                angle: -90,
                position: "left",
              }}
            />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="students"
              stroke="#c11a83"
              strokeWidth={3}
              dot={{ fill: "#c11a83", strokeWidth: 4 }}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>

      {/* Commented out circles section
      <Grid
        container
        justifyContent={"center"}
        sx={{ maxWidth: "1000px", margin: "auto" }}
      >
        {[
          { image: Images.student, number: "1710+", title: "Student" },
          { image: Images.team, number: "342+", title: "Team" },
          { image: Images.govern, number: "21+", title: "Governorate" },
          { image: Images.academy, number: "50+", title: "Organization" },
          { image: Images.category, number: "11", title: "Category" },
        ].map((item, i) => (
          <Grid
            item
            xs={6}
            sm={6}
            md={4}
            lg={4}
            key={i}
            sx={{ justifyContent: "center" }}
          >
            <Box
              sx={{
                border: "3px solid",
                borderColor: "primary.main",
                borderRadius: "50%",
                padding: { xs: "20px 10px", md: "30px 10px" },
                textAlign: "center",
                maxWidth: { xs: "150px", md: "200px" },
                margin: { xs: "10px auto", md: "10px auto" },
              }}
            >
              <img
                alt={i}
                src={item.image}
                className="circle"
                style={{
                  filter:
                    "invert(22%) sepia(52%) saturate(4198%) hue-rotate(304deg) brightness(84%) contrast(99%)",
                }}
              />
              <Typography
                variant={"h3"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "30px", md: "40px" },
                  fontWeight: "500",
                  color: "primary.darker",
                }}
              >
                {item?.number}
              </Typography>
              <Typography
                variant={"h4"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "13px", md: "20px" },
                  fontWeight: "500",
                  color: "primary.main",
                }}
              >
                {item?.title}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      */}
    </Box>
  );
};

export default Numbers;

// RobotChallenge is one of the biggest competitions for self-made, autonomous and mobile robots worldw
